import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VideoBackgroundComponent } from 'src/app/shared/ui-common/video-background/video-background.component';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-feature-sso-redirect',
  imports: [CommonModule, VideoBackgroundComponent],
  templateUrl: './feature-sso-redirect.component.html',
  styleUrl: './feature-sso-redirect.component.scss',
})
export class FeatureSsoRedirectComponent implements OnInit {
  text = 'Redirecting';

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    const queryParams = this.route.snapshot.queryParams;
    const token = queryParams['encodedJwt'];

    if (token) {
      const appUrl = `https://app.howdy.care/Web/Sso?encodedJwt=${token}`;
      window.location.href = appUrl;

      return;
    }

    setTimeout(() => {
      const redirectUrl = `${window.location.origin}/login`;
      window.location.href = redirectUrl;
    }, 2000);
  }
}
